import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  LOADING_INTERCEPTOR_TOKEN,
  SHOW_MODAL_ON_ERROR
} from '../../interceptors/interceptor.token';
import { LIB_CONFIG, LibConfig } from '../../lib.config';
import { Aggregations, EMPTY } from '../../model/aggregations';
import { checkParams } from '../../shared/utils/check-params.util';
import { UrlService } from '../state/url.service';
import {
  BildungsangebotFilterkategorien,
  createBasicHttpParamsFor
} from './bildungsangebot.client';
import { SucheError } from './suche-error';

/**
 * TODO document me: wozu diese feldauswahl?
 */
export interface FilterAggregationsBasisFilterParameter extends Pick<
  BildungsangebotFilterkategorien,
  'suchwort' | 'umkreis' | 'ortsunabhaengig' | 'correctionState' | 'berufe'
> {}

/**
 * Client kapselt die Zugriffe auf das Backend bzgl. FilterAggregations
 */
@Injectable({
  providedIn: 'root'
})
export class FacettenAggregationsClient {
  private readonly libConfig = inject<LibConfig>(LIB_CONFIG);
  private readonly http = inject(HttpClient);

  public static SERVER_ERROR = 'SUCHE_FACETTENAGGREGATION_SERVER_ERROR';

  /**
   * Hole eine die FilterAggregations von Angeboten anhand der in die httpParams codierten Filtern
   */
  public getFilterAggregations = (
    facettenParameter: { param: string; ids: string[] }[],
    filterParameter: FilterAggregationsBasisFilterParameter
  ): Observable<Aggregations> => {
    const httpParams = this.prepareRequest(facettenParameter, filterParameter);
    return this.http
      .get<Aggregations>(`${this.libConfig.backendHost}/pc/v1/facettenaggregations`, {
        params: checkParams(httpParams),
        responseType: 'json',
        context: new HttpContext()
          .set(SHOW_MODAL_ON_ERROR, true)
          .set(LOADING_INTERCEPTOR_TOKEN, 'facetten')
      })
      .pipe(
        map((agg) => {
          return { ...agg };
        }),
        catchError((error) => {
          if (error.status === 400) {
            return of(EMPTY());
          }
          throw new SucheError('Fehler beim Laden der Facettenaggregations', error);
        })
      );
  };

  public getAnbieterAggregations = (
    facettenParameter: { param: string; ids: string[] }[],
    filterParameter: FilterAggregationsBasisFilterParameter
  ): Observable<Aggregations> => {
    const httpParams = this.prepareRequest(facettenParameter, filterParameter);
    return this.http
      .get<Aggregations>(`${this.libConfig.backendHost}/pc/v1/facettenaggregations/anbieter`, {
        params: checkParams(httpParams),
        responseType: 'json',
        context: new HttpContext()
          .set(SHOW_MODAL_ON_ERROR, true)
          .set(LOADING_INTERCEPTOR_TOKEN, 'anbieterfacette')
      })
      .pipe(
        catchError((error) => {
          if (error.status === 400) {
            return of(EMPTY());
          }
          throw new SucheError('Fehler beim Laden der Anbieteraggregations', error);
        })
      );
  };

  private prepareRequest(
    facettenParameter: { param: string; ids: string[] }[],
    filterParameter: FilterAggregationsBasisFilterParameter
  ) {
    let httpParams = createBasicHttpParamsFor(filterParameter);
    // Füge alle Parameter der Facetten hinzu
    httpParams = facettenParameter
      .filter(({ ids }) => ids.length > 0)
      .reduce(
        (httpParams, { param, ids }) => httpParams.set(param, ids.join(UrlService.VALUE_SEPARATOR)),
        httpParams
      );
    return httpParams;
  }
}
